export default __webpack_public_path__ + "static/media/dropdown_arrow.bbe53b0e.svg";